import { jsx as _jsx } from "react/jsx-runtime";
import { x } from '@xstyled/styled-components';
import { colors } from '../theme/colors';
export var CloseButton = function CloseButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(x.button, {
    color: colors.textForeground,
    hoverColor: colors.textPrimary,
    transition: "color 0.1s ease-in-out",
    fontSize: "2xl",
    bg: "transparent",
    position: "absolute",
    top: "16px",
    right: "16px",
    focusOutline: "none",
    onClick: onClick,
    children: children
  });
};